/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the MIT License. See the accompanying LICENSE file for terms.
 */

import PropTypes from 'prop-types'
import { DragLayer } from 'react-dnd'

import { _Beat } from './Beat'

function collect (monitor) {
    var item = monitor.getItem();
    return {
        id: item && item.id,
        name: item && item.name,
        currentOffset: monitor.getSourceClientOffset(),
        isDragging: monitor.isDragging()
    };
}

function getItemStyles (currentOffset) {
    if (!currentOffset) {
        return {
          display: 'none'
        };
    }

    // http://www.paulirish.com/2012/why-moving-elements-with-translate-is-better-than-posabs-topleft/
    var x = currentOffset.x;
    var y = currentOffset.y;

    return {
        pointerEvents: 'none',
        top: `${y}px`,
        left: `${x}px`,
    };
}

function _BeatDragPreview ({
    id,
    name,
    isDragging,
    currentOffset,
    findBeat,
    scaleFactor
}) {
    if (!isDragging) {
        return <div className="drag-preview"></div>;
    }

    const { beat, index } = findBeat(id);
    const beatProps = Object.assign({}, beat, { index: index, title: (index + 1).toString(), editable: false, scaleFactor: scaleFactor });

    return (
        <div
            className="drag-preview"
            style={getItemStyles(currentOffset)}
        >
            <_Beat
              findBeat={findBeat}
              selectBeat={() => {}}
              editBeat={() => {}}
              moveBeat={() => {}}
              connectDragSource={() => {}}
              isDragging={false}
              y={0}
              {...beatProps}
            />
        </div>
    );
}

_BeatDragPreview.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    currentOffset: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number
    }),
    isDragging: PropTypes.bool,
    findBeat: PropTypes.func,
    scaleFactor: PropTypes.number
};

// export default DragLayer(collect)(ItemPreview);
window.BeatDragPreview = DragLayer(collect)(_BeatDragPreview);

export default BeatDragPreview;